import React from 'react';
import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { CatalogueEntry } from "../CatologueEntry"
import DataCache from "../../StaticData/StaticDataCache";
import { IGeneralApiClient } from "../../../Common/ApiClients/GeneralApiClient";
import { Catalogue } from "@singularsystems/neo-react-services";
import * as Roles from "../../../AccessControl/Models/Commands/Security/Roles"
import StaticTaxTypeLookup from '../../../Common/Models/StaticTaxTypeLookup';
import StaticClientEntityTypeLookup from '../../../Common/Models/StaticClientEntityTypeLookup';
import StaticClientEntityTaxLookup from '../../../Common/Models/StaticEntityTaxLookup';
import StaticEntityTaxLookup from '../../../Common/Models/StaticEntityTaxLookup';

export default class EntityTaxCatalogueEntry extends CatalogueEntry<StaticEntityTaxLookup> {

    constructor() {
        super("Entity Taxes", StaticEntityTaxLookup);
    }

    public get editRole() {
        return Roles.CatalogueRoles.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.entityTax;
    }
    
    public getSaveEndpoint(apiClient: IGeneralApiClient) {
        return apiClient.saveEntityTax;
    }
    
    public renderRow(item: StaticClientEntityTaxLookup, meta: Model.TransformMetaType<StaticEntityTaxLookup>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column display={meta.clientEntityTypeName} />
                <NeoGrid.Column display={meta.taxTypeDescription} />  
                <NeoGrid.Column bind={meta.effectiveStartDate} />           
                <NeoGrid.Column bind={meta.taxRate} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}